import {createPortal} from 'react-dom'
import '../styles/components/modal.css';
import Button from './Button'

const Modal = ({
                   icon,
                   title,
                   children,
                   primaryButton,
                   secondaryButton,
                   isOpen,
                   shouldCloseOnBackgroundClick = false,
                   onBackgroundClick
               }) => {
    if (!isOpen) return null

    const modalRoot = document.getElementById('modal-root')
    if (!modalRoot) return null

    return createPortal(
        <>
            <div
                role="presentation"
                className="modal-overlay"
                onClick={shouldCloseOnBackgroundClick ? onBackgroundClick : undefined}
            />
            <div className="modal-container">
                <div className="modal-content">
                    <img src={icon} alt="" className="modal-icon"/>
                    <h2 className="modal-title gmarket-font">{title}</h2>
                    <div className="modal-body">
                        {children}
                    </div>
                    <div className="modal-footer">
                        {primaryButton && (
                            <Button
                                className="modal-button-primary"
                                onClick={primaryButton.onClick}
                            >
                                {primaryButton.text}
                            </Button>
                        )}
                        {secondaryButton && (
                            <Button
                                className="modal-button-secondary"
                                onClick={secondaryButton.onClick}
                            >
                                {secondaryButton.text}
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </>,
        modalRoot
    )
}

export default Modal